export default "__VITE_ASSET__C81O9wrD__"